import { createContext, useContext } from 'react';

type IActiveLookupContext = {
  activeLookup: string;
  setActiveLookup: (activeLookup: string) => void;
};

const ActiveLookupContext = createContext<IActiveLookupContext>({
  activeLookup: '',
  setActiveLookup:() => void 0
});

const useActiveLookupContext = () => {
  return useContext(ActiveLookupContext);
};

export { useActiveLookupContext, ActiveLookupContext };
